(() => {
  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase();

  const initFaqSearch = (root) => {
    if (!root || root.dataset.jdcFaqSearchReady === 'true') return;

    const input = root.querySelector('[data-jdc-faq-search-input]');
    const clear = root.querySelector('[data-jdc-faq-search-clear]');
    const empty = root.querySelector('[data-jdc-faq-search-empty]');
    const status = root.querySelector('[data-jdc-faq-search-status]');
    const categories = root.querySelector('.faq__categories');
    const items = root.querySelector('.faq__items');

    if (!input || !items) return;

    const details = Array.from(items.querySelectorAll('.faq__details'));
    const headings = Array.from(items.querySelectorAll('.faq__heading'));
    const update = () => {
      const query = normalize(input.value.trim());
      let visibleCount = 0;

      details.forEach((detail) => {
        const matches = !query || normalize(detail.textContent).includes(query);
        detail.hidden = !matches;

        if (matches) visibleCount += 1;
      });

      headings.forEach((heading) => {
        let sibling = heading.nextElementSibling;
        let hasVisibleQuestion = false;

        while (sibling && !sibling.classList.contains('faq__heading')) {
          if (sibling.classList.contains('faq__details') && !sibling.hidden) {
            hasVisibleQuestion = true;
          }
          sibling = sibling.nextElementSibling;
        }

        heading.hidden = Boolean(query) && !hasVisibleQuestion;
      });

      if (categories) categories.hidden = Boolean(query);
      if (clear) clear.hidden = !query;
      if (empty) empty.hidden = !query || visibleCount > 0;
      if (status) {
        status.textContent = query
          ? `${visibleCount} ${visibleCount > 1 ? 'résultats' : 'résultat'}`
          : '';
      }
    };

    input.addEventListener('input', update);
    input.addEventListener('search', update);

    if (clear) {
      clear.addEventListener('click', () => {
        input.value = '';
        update();
        input.focus({ preventScroll: true });
      });
    }

    root.dataset.jdcFaqSearchReady = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-jdc-faq-modern]').forEach(initFaqSearch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
